import { useState } from 'react';
import Button from '../ui/Button';
import { useFriends } from '../../contexts/FriendsContext';

function FormAddFriend() {
  const [name, setName] = useState('');
  const [image, setImage] = useState('https://i.pravatar.cc/48');
  const { dispatch } = useFriends();

  function handleSubmit(e) {
    e.preventDefault();

    if (!name || !image) return;

    const id = crypto.randomUUID();
    dispatch({
      type: 'addFriend',
      payload: {
        id,
        name,
        image: `${image}?=${id}`,
        balance: 0,
      },
    });

    setName('');
    setImage('https://i.pravatar.cc/48');
  }

  return (
    <form className="form-add-friend" onSubmit={handleSubmit}>
      <label>🧑‍🤝‍🧑Friend Name</label>
      <input type="text" value={name} onChange={e => setName(e.target.value)} />

      <label>📷 Image URL</label>
      <input type="text" value={image} onChange={e => setImage(e.target.value)} />

      <Button>Add</Button>
    </form>
  );
}

export default FormAddFriend;
